<div class="region-item mt-2">
  <div class="region-details flex gap-4">
    <mat-form-field appearance="fill">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="regionData.name" required />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput [(ngModel)]="regionData.description" required />
    </mat-form-field>
    <button *ngIf="showDeleteRegion" mat-icon-button (click)="deleteRegion()" aria-label="Delete" color="error"><mat-icon>delete_forever</mat-icon></button>
  </div>

  <!-- Budget Section -->
  <div *ngIf="showBudgets" class="budgets-section mt-2 ml-4">
    <!-- 1. New Budget Form -->
    <h4>Add New Budget</h4>
    <div class="flex gap-4">
      <mat-form-field appearance="fill">
        <mat-label>Year</mat-label>
        <input matInput type="number" [(ngModel)]="newBudgetData.year" required />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Planned Budget</mat-label>
        <input matInput type="number" [(ngModel)]="newBudgetData.plannedBudget" required />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Actual End Year</mat-label>
        <input matInput type="number" [(ngModel)]="newBudgetData.actualYearEndBudget" required />
      </mat-form-field>

      <button mat-flat-button color="primary" (click)="addBudget()" [disabled]="!isBudgetValid()">Add Budget</button>
    </div>

    <!-- 2. Existing Budgets List -->
    <h4 *ngIf="regionData.budgets?.length" class="mt-4">Budgets</h4>
    <div *ngFor="let budget of regionData.budgets; let i = index" class="budget-item flex gap-4 mt-2">
      <mat-form-field appearance="fill">
        <mat-label>Year</mat-label>
        <input matInput type="number" [(ngModel)]="budget.year" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Planned Budget</mat-label>
        <input matInput type="number" [(ngModel)]="budget.plannedBudget" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Actual End Year</mat-label>
        <input matInput type="number" [(ngModel)]="budget.actualYearEndBudget" />
      </mat-form-field>

      <button mat-icon-button (click)="removeBudget(i)" aria-label="Remove Budget" color="error"><mat-icon>delete_forever</mat-icon></button>
    </div>
  </div>
</div>
